
import { ICON_BASE_PATH } from "../../../../utils/config";
import { TextBox, type TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { t } from "i18next";

interface ContactNameProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  validationMessage?: string;
  className?: string;
  starlable?: boolean;
  disable?: boolean;
  max?: number;
}

const ContactName: React.FC<ContactNameProps> = ({
  label="",
  value,
  onChange,
  validationMessage,
  starlable = true,
  disable = false,
  max,
}) => {
  const sanitize = (s: string) => s.replace(/[^\p{L}\s]/gu, "");

  const handleChange = (e: TextBoxChangeEvent) => {
    const raw = String(e.value ?? "");
    let filtered = sanitize(raw);

    if (max && filtered.length > max) {
      filtered = filtered.slice(0, max);
    }
    onChange(filtered);
  };

  return (
    <div className="gx_input_container">
      <label
        className={`input-label gx-font-semibold ${
          value?.trim() ? "floating" : ""
        }`}
      >
         {t(label)}
        {starlable && (
          <span
            className={`gx_input_star ${
              value?.trim() ? "gx_input_star_float" : "gx_input_star_normal"
            }`}
          >
            *
          </span>
        )}
      </label>

      <div
        className={`gx_input_cont ${
          !validationMessage || value ? "valid" : "invalid"
        }`}
      >
        <img src={`${ICON_BASE_PATH}companyicon.svg`} alt="name" />

        <TextBox
          value={value}
          onChange={handleChange}
          type="text"
          autoComplete="off"
          max={max}
          disabled={disable}
          className="gx-textbox-css"
        />
      </div>

      {validationMessage && (
        <div className="gx_input_validationmessage">{validationMessage}</div>
      )}
    </div>
  );
};

export default ContactName;
